import React from "react";
import { Box, Typography } from "@material-ui/core";
import useAppBarHeaderStyles from "./AppBarHeaderStyles";

const AppBarHeader: React.FC = () => {
	const classes = useAppBarHeaderStyles();
	return (
		<Box className={classes.root}>
			<Box><img src={"/images/jb-logo.png"} alt="logo" className={classes.logo} /></Box> 			
			<Box>
				<Typography variant="h4">Replenishment App</Typography>
			</Box>
		</Box>
	);
};
export default AppBarHeader;
